import React, { ComponentPropsWithoutRef, forwardRef } from 'react';
import { StyledFmToggleButton } from './FmToggleButton.styles';

export interface Props extends ComponentPropsWithoutRef<'button'> {
  isPressed?: boolean;
}

export const FmToggleButton = forwardRef<HTMLButtonElement, Props>(
  ({ isPressed, ...rest }: Props, ref) => {
    return <StyledFmToggleButton {...rest} aria-pressed={isPressed} ref={ref} />;
  },
);
